// extracted by mini-css-extract-plugin
export default {"details_container":"AttorneyDetail_details_container__O1LOD","day_one_container":"AttorneyDetail_day_one_container__mql+k"};